import {ChangeDetectorRef, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {ApiService} from "../../../services/api/api.service";
import {DateTimePeriodService} from "../../../services/date-time-period.service";
import {EventService} from "../../../services/event.service";
import {SeriesAuditHistoryService} from "../series-audit-history.service";
import {DateTimeInstanceService} from "../../../services/date-time-instance.service";
import {Series} from "../../../_models/series";
import {IDateTimePeriod} from "../../../_typing/date-time-period";
import {Event as WireEvent} from "../../../_models/event";
import {MatPaginator} from "@angular/material/paginator";
import {take, takeUntil, tap} from "rxjs/operators";
import {SeriesAuditHistoryTable} from "../series-audit-history.component";
import {BaseComponent} from "../../../shared/base.component";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {SeriesFormDialogService, SeriesReportingTabs} from "../../../forms/series-form-dialog/series-form-dialog.service";
import {UtilsBarComponent} from "../../../tables/utils-bar/utils.bar.component";
import {COMMON_FORM_IMPORTS, COMMON_TABLE_IMPORTS } from "../../../shared/import-groups/Common";
import {SharedPipesModule} from "../../../shared/modules/shared-pipes.module";
import {SeriesAuditStatisticsComponent} from "../series-audit-statistics/series-audit-statistics.component";



@Component({
    selector: 'consolidated-series-audit-history',
    templateUrl: './consolidated-series-audit-history.component.html',
    styleUrl: './consolidated-series-audit-history.component.scss',
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    imports: [
        UtilsBarComponent,
        COMMON_TABLE_IMPORTS,
        MatSortHeader,
        SharedPipesModule,
        COMMON_FORM_IMPORTS,
        SeriesAuditStatisticsComponent
    ],
})
export class ConsolidatedSeriesAuditHistoryComponent extends BaseComponent {
    pageNumber: number = 0;
    pageSize = 10;
    pagedHistory: any[];
    current_page: any;
    times: any = []

    constructor(private api: ApiService,
                private dateTimePeriodService: DateTimePeriodService,
                private eventService: EventService,
                private cps: SeriesAuditHistoryService,
                private dateInst: DateTimeInstanceService,
                private dialogService: SeriesFormDialogService,
                private cdr: ChangeDetectorRef
    ) {
        super();
    }

    _series: Series;

    get series(): Series {
        return this._series;
    }

    @Input()
    set series(_series: Series) {
        this._series = _series;
    }

    @Input() dtp: IDateTimePeriod;
    data: SeriesAuditHistoryTable[];
    dataSource: MatTableDataSource<SeriesAuditHistoryTable>;
    columns: string[] = ['expand', 'timestamp', 'value', 'old_value', 'changed_by', 'changed_on', 'comments'];
    comments: WireEvent[];
    filterString: string = "";

    expandedElement: any | null = {};
    loading = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;

    private sort;

    @ViewChild(MatSort) set content(content: ElementRef) {
        this.sort = content;
        if (this.sort && this.dataSource) {
            this.dataSource.sort = this.sort;
        }
    }

    ngOnInit(): void {
        this.pageNumber = 0;
        this.dataSource = new MatTableDataSource();

        this.dateInst.dateTimePeriodRefreshed$.pipe(takeUntil(this.onDestroy)).subscribe((dtp) => {
            this.dateInst.dtp = dtp;
            this.loading = true;
            this.cps.getConsolidatedSeriesAuditHistory(this.series, dtp);
        })

        this.cps.$consolidatedAuditHistoryData.pipe(takeUntil(this.onDestroy),
            tap(data => {
                this.loading = false;
                this.dataSource.data = data;
                this.setupTable();
            })).subscribe();

        this.dateInst.dateTimePeriodInitialised$.pipe(take(1)).subscribe(() => {
            this.loading = true;
            this.cps.getConsolidatedSeriesAuditHistory(this.series, this.dateInst.dtp);
        })
    }

    setupTable() {
        this.dataSource.data.sort((a, b) => {
            return a.timestamp < b.timestamp ? 1 : a.timestamp > b.timestamp ? -1 : 0;
        });
        this.dataSource.filterPredicate = (data, filter) => {
            if ((data.changed_by && data.changed_by.toLowerCase().includes(filter))
                || (data.value && data.value.toString().includes(filter))
                || (data.old_value && data.old_value.toString().includes(filter))
            ) {
                return true;
            }
            return false;
        };

        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (data, sortHeaderId) => {
            switch (sortHeaderId) {
                default:
                    return data[sortHeaderId];
                    break;
            }
        };

        this.dataSource.paginator = this.paginator;
    }

    toggleRow(item: any): void {
        this.expandedElement[item.id] = !this.expandedElement[item.id];
    }

    loadSubHourlyData(item) {
        this.cps.$currentHour.next(item.timestamp);
        this.dialogService.setTab(SeriesReportingTabs.SUB_AUDIT)
    }

    applyFilter(filterValue: any) {
        filterValue = filterValue?.trim().toLowerCase() ?? '';
        this.dataSource.filter = filterValue;
    }

}
